export default "__VITE_ASSET__Dzzo557J__"